export default __webpack_public_path__ + "static/2020-Car-Show-Magazine-3f9ecf0147ead20659a6db03eae740a1.pdf";